const FullGridIcon = () => `<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16 8H8L8 16H16V8ZM8 6C6.89543 6 6 6.89543 6 8V16C6 17.1046 6.89543 18 8 18H16C17.1046 18 18 17.1046 18 16V8C18 6.89543 17.1046 6 16 6H8Z"
    fill="currentColor"
  />
</svg>`;
export default FullGridIcon;
